import { Length, Weight } from "@cur8/measurements";

export function calcBMI(weight: Weight, height: Length) {
  return weight.kilograms / height.meters ** 2;
}
